<template>
  <div class="welcome">
    <div class="box">
      <i class="el-icon-loading"></i>
    </div>
  </div>
</template>

<script>
export default {
  name: 'welcome',
  data() {
    return {
      params: {},
      code: '',
      id: ''
    }
  },
  mounted() {
    if (this.$route.params.targetName === 'Invoice') {
      return this.$dialog
        .alert({
          message: '开发中！'
        })
        .then(() => {
          // eslint-disable-next-line no-undef
          WeixinJSBridge.call('closeWindow')
        })
    }
    this.params = this.getUrlParam(window.location.href)
    if (this.$route.params.targetName === 'Sign') {
      // 员工绑定微信
      this.$router.push({
        name: 'Sign',
        params: {
          id: this.$route.params.id,
          code: this.$route.params.code
        }
      })
    } else if (this.$route.params.targetName === 'Third') {
      // 客户绑定微信
      this.$router.push({
        name: 'Third',
        params: {
          id: this.$route.params.id,
          code: this.$route.params.code
        }
      })
    } else if (this.$route.params.targetName === 'experience') {
      // 体验入口
      this.$router.push({
        name: 'BlankTest',
        params: {
          id: this.$route.params.id,
          targetName: this.$route.params.targetName,
          code: this.$route.params.code
        }
      })
    } else if (this.$route.params.targetName === 'LoginBindFlow') {
      // 转让微信注册
      this.$router.push({
        name: 'LoginBindFlow',
        params: {
          id: this.$route.params.id,
          targetName: this.$route.params.targetName,
          code: this.$route.params.code
        }
      })
    } else if (this.$route.params.targetName === 'LoginFlow') {
      // 转让微信注册
      this.$router.push({
        name: 'LoginFlow',
        params: {
          id: this.$route.params.id,
          targetName: this.$route.params.targetName,
          code: this.$route.params.code
        }
      })
    } else if (this.$route.params.targetName === 'FlowAudit') {
      // 转让微信注册
      this.$router.push({
        name: 'FlowAudit',
        params: {
          id: this.$route.params.id,
          targetName: this.$route.params.targetName,
          code: this.$route.params.code
        }
      })
    } else if (this.$route.params.targetName === 'Flow') {
      // 转让微信注册
      this.$router.push({
        name: 'FlowAudit',
        params: {
          id: this.$route.params.id,
          targetName: this.$route.params.targetName,
          code: this.$route.params.code
        }
      })
    } else {
      this.wechatLogin()
    }
  },
  methods: {
    // 解析页面URL
    getUrlParam(url) {
      var paramStr = url.substring(url.indexOf('?') + 1, url.length).split('&')
      var j
      var paramObj = {}
      for (var i = 0; (j = paramStr[i]); i++) {
        console.log(i)
        paramObj[j.substring(0, j.indexOf('='))] = j.substring(j.indexOf('=') + 1, j.length)
      }
      var returnValue = paramObj
      if (typeof returnValue === 'undefined') {
        return ''
      } else {
        return returnValue
      }
    },
    // 微信登录
    wechatLogin() {
      const param = {
        // id: this.$route.params.id,
        code: this.$route.params.code,
        menu: this.$route.params.targetName.toLocaleLowerCase()
      }
      this.$get('/login/wechatLogin', param).then(
        result => {
          if (result.status === 200) {
            this.$common.session.set('userInfo', result.data)
            this.$common.session.set('token', result.data.token)
            console.log(this.$route.params)
            if (this.$route.params.targetName === 'Invoice') {
              return this.$dialog
                .alert({
                  message: '开发中！'
                })
                .then(() => {
                  // eslint-disable-next-line no-undef
                  WeixinJSBridge.call('closeWindow')
                })
            }
            this.$router.push({
              name: this.$route.params.targetName,
              params: {
                id: this.$route.params.id,
                code: this.$route.params.code
              }
            })
          } else {
            if (result.status === -2) {
              // 员工页面，未注册跳转
              this.$common.session.remove('signForm')
              const targetName = this.$route.params.targetName
              if (targetName === 'Case' || targetName === 'Customer' || targetName === 'Flow') {
                this.$common.session.set('SignTargetName', this.$route.params.targetName)
                this.$dialog
                  .alert({
                    message: result.msg
                  })
                  .then(() => {
                    this.$router.push({
                      name: 'Sign',
                      params: {
                        id: this.$route.params.id,
                        code: ''
                      }
                    })
                  })
              }
              // 客户页面，未注册跳转
              this.$common.session.remove('thirdForm')
              if (targetName === 'Invoice') {
                this.$common.session.set('ThirdTargetName', this.$route.params.targetName)
                this.$dialog
                  .alert({
                    message: result.msg
                  })
                  .then(() => {
                    this.$router.push({
                      name: 'Third',
                      params: {
                        id: this.$route.params.id,
                        code: ''
                      }
                    })
                  })
              }
            } else if (result.msg === '获取微信用户唯一标识失败') {
              // this.$dialog
              //   .alert({
              //     message: result.msg
              //   })
              //   .then(() => {
              window.location.href =
                './?wechatLogin=true&targetName=' +
                this.$route.params.targetName +
                '&id=' +
                this.$route.params.id +
                '&state=111'
              // })
            } else {
              this.$dialog
                .alert({
                  message: result.msg
                })
                .then(() => {
                  // eslint-disable-next-line no-undef
                  WeixinJSBridge.call('closeWindow')
                })
            }
            // this.$dialog
            //   .alert({
            //     message: result.msg
            //   })
            //   .then(() => {
            //     // eslint-disable-next-line no-undef
            //     // WeixinJSBridge.call('closeWindow')
            //   })
          }
        },
        error => {
          this.$dialog.alert({
            message: error.name + ':' + error.message
          })
        }
      )
    },
    // 微信登录
    wechatExperientialLogin() {
      const param = {
        loginname: 'A123456',
        password: '888888',
        code: this.$route.params.code
      }
      this.$post('/login/doLogin', param).then(
        result => {
          if (result.status === 200) {
            this.$common.session.set('userInfo', result.data)
            this.$common.session.set('token', result.data.token)
            console.log(this.$route.params)
            this.$router.push({
              name: 'Customer',
              params: {
                id: this.$route.params.id,
                code: this.$route.params.code
              }
            })
          } else {
            this.$dialog
              .alert({
                message: result.msg
              })
              .then(() => {
                // eslint-disable-next-line no-undef
                WeixinJSBridge.call('closeWindow')
              })
          }
        },
        error => {
          this.$dialog.alert({
            message: error.name + ':' + error.message
          })
        }
      )
    }
  },
  destroyed() {}
}
</script>

<style lang="less" scoped>
.welcome {
  .box {
    width: 100%;
    height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;
    i {
      font-size: 10vw;
      color: #000;
    }
  }
}
</style>
